// Seiteneffekt-Import: registriert alle PA-Singletons in der PARegistry, bevor Klassen zugreifen
import "./singletons/pa-singleton-bootstrap";
import { PAApiServices } from "./classes/pa-api-services";
import { PaNotificationsComponent } from "./reuseable-components/pa-notifications/pa-notifications.component";
import { TourDebugDialogComponent } from "./tour-debug/tour-debug-dialog.component";
import { PopoutWindowComponent } from "./reuseable-components/popout-window/popout-window.component";
import { PAFilterControl } from "./singletons/pa-filter-control";
import { PATourPlannerControl } from "./singletons/pa-tourplanner-control";
import { PASettingsControl } from "./singletons/pa-settings-control";
import { PADataControl } from "./singletons/pa-data-control";
import { PATimeControl } from "./singletons/pa-time-control";
import { PAStoreControl } from "./singletons/pa-store-control";
import { PAMapControl } from "./singletons/pa-map-control";
import { PlanningAssistantSettingsService } from "./services/planning-assistant-settings.service";
import { NgClass } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonToggleGroup, MatButtonToggle, MatButtonToggleModule } from "@angular/material/button-toggle";
import { PopupModalComponent } from "./reuseable-components/popup-modal/popup-modal.component";
import { PaSettingsComponent } from "./pa-settings/pa-settings.component";
import { TourplannerMenuComponent } from "./tourplanner-menu/tourplanner-menu.component";
import { SaveMenuComponent } from "./save-menu/save-menu.component";
import { ExpandBarHeaderComponent } from "./reuseable-components/expand-bar-header/expand-bar-header.component";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { IconExpandBarComponent } from "./reuseable-components/icon-expand-bar/icon-expand-bar.component";
import { StoreOperationsComponent } from "./reuseable-components/store-operations/store-operations.component";
import { MapComponent } from "./map/map.component";
import { encodePlanTechnicianLoadingCaseParams, encodePlanTicketsLoadingCaseParams } from "./pa-loading-case-params";
import { TourComparisonComponent } from "./tour-comparison/tour-comparison.component";
import { LoadingContainerComponent } from "./reuseable-components/loading-container/loading-container.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { InsufficientDataPopupComponent } from "./insufficient-data-popup/insufficient-data-popup.component";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ArticleService,
  OperationService,
  ProjectService,
  StoreService,
  TicketNoteService,
  TicketService,
  UserService,
} from "src/app/_services";
import { PlanningAssistantOperation as PAOperationHash } from "src/app/_models/planning-assistant.interface";

import { PlanningAssistantService } from "src/app/_services/planning-assistant.service";
import { TravelTechnicianDateService } from "src/app/_services/travel_technician_date.service";
import screenfull from "screenfull";
import {
  faArrowCircleRight,
  faBookOpen,
  faCalendar,
  faCheck,
  faCog,
  faCompress,
  faExpand,
  faExternalLinkAlt,
  faTrash,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { PATechnician } from "./classes/technician";
import { PAUtil, WeekDay } from "./classes/util";
import { PAProject } from "./classes/project";
import { PAOperation } from "./classes/operation";
import { PAStore } from "./classes/store";
import { PATechnicianDate } from "./classes/technician-date";
import { TravelTechnicianDate } from "./classes/travel-technician-date";
import { PATicket } from "./classes/ticket";
import { FilterComponent } from "./filter/filter.component";
import { DistanceCalculator } from "./classes/location";
import { MapBoxService } from "src/app/_services/mapbox.service";
import { TechnicianDateCollection } from "./classes/technician-date-collection";
import { AbsenceService } from "../../_services/absence.service";
import { AbsenceCalendar } from "../../_models/absence.model";
import { SetTechnicianStateComponent } from "./reuseable-components/set-technician-state/set-technician-state.component";
import { TechnicianDataLoader } from "./classes/technician-data-loader";

@Component({
  selector: "hawk-planning-assistant",
  templateUrl: "./planning-assistant.component.html",
  styleUrls: ["./planning-assistant.component.scss", "./styles/common_styles.scss"],
  host: {
    "(document:click)": "onClick($event)",
  },
  standalone: true,
  imports: [
    NgClass,
    ReactiveFormsModule,
    FormsModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    PopupModalComponent,
    PaSettingsComponent,
    PopoutWindowComponent,
    TourplannerMenuComponent,
    SaveMenuComponent,
    ExpandBarHeaderComponent,
    TooltipModule,
    IconExpandBarComponent,
    StoreOperationsComponent,
    FaIconComponent,
    MapComponent,
    TourComparisonComponent,
    FilterComponent,
    LoadingContainerComponent,
    CalendarComponent,
    InsufficientDataPopupComponent,
    CommonModule,
    MatButtonModule,
    FontAwesomeModule,
    MatButtonToggleModule,
    SetTechnicianStateComponent,
    PaNotificationsComponent,
    TourDebugDialogComponent,
  ],
})
export class PlanningAssistantComponent implements OnInit, AfterViewInit {
  @ViewChild("filterComponent") filterComponent: FilterComponent;
  @ViewChild("filterComponent", { read: ElementRef }) filterComponentEref: ElementRef;
  @ViewChild("TourComparison") tourComparisonComponent: TourComparisonComponent;

  // Route params
  public paramLoadingMode: "plan_ticket" | "plan_technician";
  // Plan Ticket
  public paramTicketId: string;
  public paramsOpenTechnicianDates: { user_id: number; timestamps: number[] }[];
  public routeTicketOperations: PAOperationHash[];
  public routeTicket: PATicket;
  public routeOperations: PAOperation[];
  // Plan Technician
  public paramPlanTechnicianId: string;
  public paramsOpenTechnicianDayTimestamps: number[];
  // Optional
  public paramsAutoSelectTicketIds: number[];
  public paramsSelectProjectIds: number[];
  public paramUseCalendarTimestamp: number;

  // font awesome
  faTrash = faTrash;
  faExpand = faExpand;
  faCompress = faCompress;
  faCheck = faCheck;
  faCalendar = faCalendar;
  faExternalLinkAlt = faExternalLinkAlt;
  faWindowClose = faWindowClose;

  public Operation = PAOperation;
  public Ticket = PATicket;
  public Project = PAProject;
  public Util = PAUtil;
  public Technician = PATechnician;
  public Store = PAStore;
  public PlanningAssistantComponent = PlanningAssistantComponent;
  public FilterComponent = FilterComponent;

  // Operation Time
  static work_window_start: number = 6;

  // UI
  public screenfull = screenfull;

  public selectedPlanningTab = "manual";

  //load data selection
  public showProjectLoadingScreen = false;
  public loadDataConfig = "";
  public selectedProjectsToLoad: PAProject[] = [];
  public projectNameFilter = "";
  projectsLoaded: boolean = false;
  serviceProjectsToggleGroup: string = "";

  public showStoreOperations: boolean = false;


  setStateTechnician: PATechnician;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ticketService: TicketService,
    private ticketNoteService: TicketNoteService,
    private articleService: ArticleService,
    private userService: UserService,
    private absenceService: AbsenceService,
    private operationService: OperationService,
    private projectService: ProjectService,
    private planningAssistantService: PlanningAssistantService,
    private travelTechnicianDateService: TravelTechnicianDateService,
    private technicianDataLoader: TechnicianDataLoader,
    public mapBoxLoadingService: MapBoxService,
    public settingsService: PlanningAssistantSettingsService,
    public storeService: StoreService,
    private absenceCalendar: AbsenceCalendar,
  ) {}

  async ngAfterViewInit(): Promise<void> {}

  async ngOnInit(): Promise<void> {
    await this.initAbsences();

    this.initLoadingParams();
    this.showProjectLoadingScreen = !this.paramLoadingMode;
    PATimeControl.Instance.initCalendar(this.paramUseCalendarTimestamp);

    this.setInstanceServices();
    await this.loadProjects();

    PADataControl.Instance.loadArticleTemplates();
    await PASettingsControl.Instance.loadSettingsFromDatabase();

    await this.handleLoadingCases();
  }

  private async initAbsences() {
    await this.absenceCalendar.loadAbsenceUsers();
    PADataControl.Instance.absenceCalendar = this.absenceCalendar;
  }

  initLoadingParams(): void {
    const param_map = this.route.snapshot.queryParamMap;
    this.paramLoadingMode = param_map.get("mode") as "plan_ticket" | "plan_technician";
    if (this.paramLoadingMode == "plan_ticket") {
      this.handleTicketLoadingParams();
    } else if (this.paramLoadingMode == "plan_technician") {
      this.handleTechnicianLoadingParams();
    }
    this.handleProjectAutoSelectionParams();
  }

  private handleTicketLoadingParams() {
    const param_map = this.route.snapshot.queryParamMap;
    this.paramTicketId = param_map.get("ticket_id");
    const encoded_technician_dates = param_map.getAll("technician_dates");
    this.paramsOpenTechnicianDates = encoded_technician_dates.map((etc) => {
      const [user_id, encoded_timestamps] = etc.split(":");
      return {
        user_id: Number.parseInt(user_id),
        timestamps: encoded_timestamps ? encoded_timestamps.split(";").map((ts) => Number.parseInt(ts)) : [],
      };
    });

    const earliest_day_ts = Math.min(...this.paramsOpenTechnicianDates.map((td) => Math.min(...td.timestamps)));
    this.paramUseCalendarTimestamp = earliest_day_ts < Infinity ? earliest_day_ts : undefined;

    this.handleTicketAutoSelectionParams();
  }

  private handleTechnicianLoadingParams() {
    const param_map = this.route.snapshot.queryParamMap;
    const encoded_technician_params = param_map.get("plan_technician_id");
    const [user_id, timestamps] = encoded_technician_params.split(":");
    this.paramPlanTechnicianId = user_id;
    this.paramsOpenTechnicianDayTimestamps = timestamps ? timestamps.split(";").map((ts) => Number.parseInt(ts)) : [];

    const earliest_day_ts = Math.min(...this.paramsOpenTechnicianDayTimestamps);
    this.paramUseCalendarTimestamp = earliest_day_ts < Infinity ? earliest_day_ts : undefined;

    this.handleTicketAutoSelectionParams();
  }

  private handleTicketAutoSelectionParams(): void {
    const param_map = this.route.snapshot.queryParamMap;
    const auto_select_params = param_map.getAll("auto_select");
    this.paramsAutoSelectTicketIds = auto_select_params ? auto_select_params.map((s) => Number.parseInt(s)) : [];
  }

  private handleProjectAutoSelectionParams(): void {
    const param_map = this.route.snapshot.queryParamMap;
    const auto_select_params = param_map.getAll("project_ids");
    this.paramsSelectProjectIds = auto_select_params ? auto_select_params.map((s) => Number.parseInt(s)) : [];
  }

  private async handleLoadingCases(): Promise<void> {
    if (this.paramLoadingMode == "plan_technician") {
      await this.handleTechnicianLoadingCase();
    } else if (this.paramLoadingMode == "plan_ticket") {
      await this.handleTicketLoadingCase();
    }
  }

  private async handleTicketLoadingCase() {
    await this.loadPlanningInstanceFromRoute();
    if (
      (this.routeOperations && this.routeOperations[0]
        ? this.routeOperations[0].ticket
        : this.routeTicket
      )?.project.isServiceProject()
    )
      PASettingsControl.Instance.projectMode = "service";
    this.handleRouteOperationsAndTickets();

    const load_data_config = this.paramsSelectProjectIds?.length
      ? "param_projects"
      : PASettingsControl.Instance.projectMode == "service"
        ? "service_projects"
        : "all_except_internal_project";
    await Promise.all([await this.selectOperationPlanningTechnicians(), await this.loadData(load_data_config)]);
  }

  private async selectOperationPlanningTechnicians(): Promise<void> {
    const tdcs: TechnicianDateCollection[] = [];
    const technicians: PATechnician[] = [];

    for (const td of this.paramsOpenTechnicianDates) {
      const tdc = new TechnicianDateCollection(PADataControl.Instance.getTechnician(td.user_id));
      await tdc.addTechnicianDatesForDayTimestamps(td.timestamps);

      tdcs.push(tdc);
      technicians.push(tdc.technician);
    }

    PAFilterControl.Instance.preferredCalendarTechnicians = technicians;
    PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections = tdcs;
  }

  private async handleTechnicianLoadingCase() {
    await this.openTourPlannerTechnicianDatesForTechnicianPlanning();
    const load_data_config = this.paramsSelectProjectIds?.length ? "param_projects" : "all_except_internal_project";
    await this.loadData(load_data_config);
  }

  private async openTourPlannerTechnicianDatesForTechnicianPlanning() {
    const id = Number.parseInt(this.paramPlanTechnicianId);
    const open_technician_timestamps = this.paramsOpenTechnicianDayTimestamps?.length
      ? this.paramsOpenTechnicianDayTimestamps
      : [PATimeControl.Instance.dateToTimestamp(new Date(), true, true)];
    const technician_dates = open_technician_timestamps.map((ts) =>
      PADataControl.Instance.getTechnician(id).getTechnicianDate(ts, true, true),
    );
    await Promise.all(
      technician_dates.map(async (td) => {
        await PAUtil.sleepUntilConditionBreaks(() => {
          return td.loadingStatus != "loaded";
        });
        await td.tour.updateRoute(true);
      }),
    );
    PATourPlannerControl.Instance.planTechnicianDates(technician_dates);
  }

  onClick(event) {
    if (this.filterComponentEref && !this.filterComponentEref.nativeElement.contains(event.target)) {
      this.filterComponent.closeAllFilters();
    }
  }

  async loadPlanningInstanceFromRoute(): Promise<void> {
    await new Promise<void>((resolve) => {
      this.planningAssistantService.getTicketOperations(Number.parseInt(this.paramTicketId)).subscribe(
        (data) => {
          this.routeTicketOperations = data;
          resolve();
        },
        (err) => {
          console.log(err);
          resolve();
        },
      );
    });
    if (this.routeTicketOperations) {
      if (this.routeTicketOperations.length) {
        const unplanned_operations = this.routeTicketOperations.filter((operation) =>
          PADataControl.Instance.unassignedOperationUserIds.includes(operation.user_ids[0]),
        );
        if (unplanned_operations.length) {
          // case: ticket has unplanned operations -> set first unplanned operation to plan
          // null-Filter: operationHashToOperation überspringt Aufträge aus
          // nicht geladenen Projekten und für die Sitzung ausgeschlossene
          // Aufträge — danach kann die Liste leer sein.
          this.routeOperations = unplanned_operations
            .map((hash) => PADataControl.Instance.operationHashToOperation(hash))
            .filter((operation) => operation != null);
          PADataControl.Instance.addOperationsToLoadedOperations(this.routeOperations);

          if (this.routeOperations.length) {
            const loading_coordinates = this.routeOperations[0].ticket.location.coordinates;
            PADataControl.Instance.loadingCoordinates = {
              lat: loading_coordinates.latitude,
              lng: loading_coordinates.longitude,
            };
          }
        }
      } else {
        // case: ticket doesn't have any operations -> load and set ticket to plan
        await new Promise<void>((resolve) => {
          this.planningAssistantService.getPlanningAssistantTicket(this.paramTicketId).subscribe(
            async (data) => {
              this.routeTicket = PADataControl.Instance.ticketHashToTicket(
                data,
                PADataControl.Instance.generateNextLocationId(),
                PADataControl.Instance.generateNextClientId(),
              );
              PADataControl.Instance.loadedRouteTicketId = this.routeTicket.id;
              const loading_coordinates = this.routeTicket.location.coordinates;
              PADataControl.Instance.loadingCoordinates = {
                lat: loading_coordinates.latitude,
                lng: loading_coordinates.longitude,
              };
              resolve();
            },
            (err) => {
              console.log(err);
              resolve();
            },
          );
        });
      }
    }
  }

  async loadProjects() {
    await PADataControl.Instance.loadActiveProjects();
    await PADataControl.Instance.loadAllActiveTechnicians();
    await PADataControl.Instance.loadActivePriorityRules();

    PAFilterControl.Instance.updateShownProjects();
    this.projectsLoaded = true;
  }

  setInstanceServices(): void {
    PAApiServices.planningAssistantService = this.planningAssistantService;
    PAApiServices.ticketService = this.ticketService;
    PAApiServices.operationService = this.operationService;
    PAApiServices.technicianDataLoader = this.technicianDataLoader;
    PAProject.setProjectService(this.projectService);
    PAProject.setPlanningAssistantService(this.planningAssistantService);
    PATechnician.setPlanningAssistantService(this.planningAssistantService);
    PATechnician.setUserService(this.userService);
    TravelTechnicianDate.setTravelTechnicianDateService(this.travelTechnicianDateService);
    PATicket.setTicketService(this.ticketService);
    PATicket.setTicketNoteService(this.ticketNoteService);
    PATicket.setArticleService(this.articleService);

    PADataControl.Instance.articleService = this.articleService;
    PADataControl.Instance.planningAssistantService = this.planningAssistantService;
    PADataControl.Instance.storeService = this.storeService;
    PAFilterControl.Instance.userService = this.userService;
    PAMapControl.Instance.mapBoxService = this.mapBoxLoadingService;
    PASettingsControl.Instance.settingsService = this.settingsService;
    PADataControl.Instance.distanceCalculator = new DistanceCalculator(
      this.mapBoxLoadingService,
      this.operationService,
    );
    PATourPlannerControl.Instance.planningAssistantComponent = this;
  }

  toggleFullscreen(): void {
    if (!this.screenfull.isFullscreen) {
      if (screenfull.isEnabled) {
        this.enableFullscreen();
      }
    } else {
      if (screenfull.isEnabled) {
        this.disableFullscreen();
      }
    }
  }

  enableFullscreen(): void {
    screenfull.request();
  }

  disableFullscreen(): void {
    screenfull.exit();
  }

  public updateWeekdaysInCalendar(weekdays: WeekDay[]): void {
    if (weekdays.length) {
      PAFilterControl.Instance.filteredWeekDays = weekdays;
    }
  }

  async downloadAbsenceUsers(): Promise<void> {
    await new Promise<void>((resolve) =>
      this.absenceService.getUsers().subscribe(
        (data) => {
          PADataControl.Instance.absenceAPIUsers = data;
          resolve();
        },
        (error) => {
          console.log(error);
          resolve();
        },
      ),
    );
  }

  toggleProjectToLoad(project: PAProject): void {
    if (!this.selectedProjectsToLoad.includes(project)) {
      this.selectedProjectsToLoad.push(project);
    } else {
      PAUtil.removeElementFromList(this.selectedProjectsToLoad, project);
    }
  }

  projectLoadingConfigSelected(): boolean {
    return this.loadDataConfig == "projects" && this.selectedProjectsToLoad.length > 0;
  }

  async loadData(load_data_config: string): Promise<void> {
    this.showProjectLoadingScreen = false;

    await PAUtil.sleepUntilConditionBreaks(() => {
      return !this.projectsLoaded;
    });

    let projects: PAProject[];
    switch (load_data_config) {
      case "fast": {
        projects = [];
        break;
      }
      case "param_projects": {
        projects = PADataControl.Instance.loadedProjects.filter((p) => this.paramsSelectProjectIds.includes(p.id));
        break;
      }
      case "projects": {
        projects = [...this.selectedProjectsToLoad];
        break;
      }
      case "all_except_internal_project": {
        projects = PADataControl.Instance.loadedProjects.filter((p) => p.id != 133);
        break;
      }
      case "service_projects": {
        projects = PADataControl.Instance.loadedProjects.filter((project) => project.isServiceProject());
        break;
      }
      default: {
        projects = [...PADataControl.Instance.loadedProjects];
        break;
      }
    }

    PAFilterControl.Instance.selectedProjects = [...projects];

    await this.loadProjectData(projects);
  }

  private handleRouteOperationsAndTickets() {
    if (this.routeOperations?.length) {
      this.routeOperations.map((op) => PAStore.insertOperation(op));
      PAFilterControl.Instance.updateUnassignedOperations();
      PATourPlannerControl.Instance.tourPlannerPlanningMode = "operation";
      PATourPlannerControl.Instance.operationToPlanID = this.routeOperations[0].id;
    }

    if (this.routeTicket) {
      PAOperation.generateTemporaryTicketOperation(this.routeTicket);
      PAFilterControl.Instance.updateFilteredUnplannedOperations();
      PATourPlannerControl.Instance.tourPlannerPlanningMode = "operation";
      PATourPlannerControl.Instance.operationToPlanID = this.routeTicket.temporaryOperation.id;
    }
  }

  async loadProjectData(projects: PAProject[]): Promise<void> {
    if (projects.length) {
      for (const project of projects) {
        Promise.all([project.loadUnplannedOperationsForProject(), project.loadUnplannedTicketsForProject()]).then(
          (_) => {
            const add_operations = PADataControl.Instance.loadedOperations.filter(
              (op) =>
                this.paramsAutoSelectTicketIds &&
                this.paramsAutoSelectTicketIds.includes(op.ticket.id) &&
                op.ticket.project.id == project.id,
            );
            if (add_operations.length) {
              PAFilterControl.Instance.updateOperationFilter().then((_) => {
                PATourPlannerControl.Instance.addOperationsToTourPlanning(add_operations);
              });
            }
          },
        );
      }
    }
  }

  addPreferredTechnician(technician: PATechnician): void {
    if (!PAFilterControl.Instance.preferredCalendarTechnicians.includes(technician)) {
      PAFilterControl.Instance.preferredCalendarTechnicians =
        PAFilterControl.Instance.preferredCalendarTechnicians.concat([technician]);
      technician.fireUpdateManually();
    }
  }

  removePreferredTechnician(technician: PATechnician): void {
    if (PAFilterControl.Instance.preferredCalendarTechnicians.includes(technician)) {
      PAFilterControl.Instance.preferredCalendarTechnicians =
        PAFilterControl.Instance.preferredCalendarTechnicians.filter(
          (preferred_technician) => preferred_technician != technician,
        );
      technician.fireUpdateManually();
    }
  }

  updatePreferredTechnicians(technicians: PATechnician[]): void {
    const preferred_technicians_before = PAFilterControl.Instance.preferredCalendarTechnicians;
    PAFilterControl.Instance.preferredCalendarTechnicians = [...technicians];
    [...new Set(preferred_technicians_before.concat(technicians))].map((technician) => technician.fireUpdateManually());
  }

  popOut(window: PopoutWindowComponent): void {
    window.open();
  }

  selectAllServiceProjects(): void {
    this.selectedProjectsToLoad = PADataControl.Instance.loadedProjects.filter((project) => project.isServiceProject());
  }

  selectAllNonServiceProjects(): void {
    this.selectedProjectsToLoad = PADataControl.Instance.loadedProjects.filter((project) =>
      project.isNotServiceProject(),
    );
  }

  openSettings() {
    PASettingsControl.Instance.showSettings = true;
  }

  protected readonly PAProject = PAProject;
  protected readonly faCog = faCog;
  protected readonly faBookOpen = faBookOpen;
  protected readonly PADataControl = PADataControl;
  protected readonly PAFilterControl = PAFilterControl;
  protected readonly PATimeControl = PATimeControl;
  protected readonly PASettingsControl = PASettingsControl;
  protected readonly PATourPlannerControl = PATourPlannerControl;
  protected readonly PAMapControl = PAMapControl;
  protected readonly PAStoreControl = PAStoreControl;
  protected readonly faArrowCircleRight = faArrowCircleRight;

  saveSettingsAndReloadPage() {
    if (PASettingsControl.Instance.quickReloadSettingsHaveChanged()) {
      PASettingsControl.Instance.createOrUpdateSettingsInDatabase().then((_) => this.quickReloadPage());
    } else {
      this.quickReloadPage();
    }
  }

  quickReloadPage() {
    const reload_settings = PASettingsControl.Instance.selectedSettingConfig.data.general.reload;
    const extra_ticket_ids = PATourPlannerControl.Instance.tourPlannerExtraOperationCollection.map((op) => op.ticket.id);
    const project_ids = PAFilterControl.Instance.selectedProjects.map((p) => p.id);

    if (
      PATourPlannerControl.Instance.tourPlannerPlanningMode == "operation" &&
      PATourPlannerControl.Instance.operationToPlanID
    ) {
      const operation = this.PADataControl.Instance.getOperation(PATourPlannerControl.Instance.operationToPlanID);
      const open_tdcs = PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections;
      window.open(
        encodePlanTicketsLoadingCaseParams(this.router, operation.ticket.id, {
          additional_ticket_ids: reload_settings.operations && extra_ticket_ids.length ? extra_ticket_ids : undefined,
          project_ids: reload_settings.projects && project_ids.length ? project_ids : undefined,
          technician_dates:
            reload_settings.days && open_tdcs.length
              ? open_tdcs.map((tdc) => {
                  return {
                    user_id: tdc.technician.id,
                    utc_day_timestamps: tdc.technicianDates.map((td) => td.day.utc_timestamp),
                  };
                })
              : undefined,
        }),
        "_self",
      );
    }
    if (
      PATourPlannerControl.Instance.tourPlannerPlanningMode == "technician" &&
      PATourPlannerControl.Instance.technicianToPlanID
    ) {
      const possible_tdc = PATourPlannerControl.Instance.tourPlannerOverviewTechnicianDateCollections.find(
        (tdc) => tdc.technician.id == PATourPlannerControl.Instance.technicianToPlanID,
      );

      window.open(
        encodePlanTechnicianLoadingCaseParams(this.router, PATourPlannerControl.Instance.technicianToPlanID, {
          day_timestamps:
            reload_settings.days && possible_tdc
              ? possible_tdc.technicianDates.map((td) => td.day.utc_timestamp)
              : undefined,
          project_ids: reload_settings.projects && project_ids.length ? project_ids : undefined,
          ticket_ids: reload_settings.operations && extra_ticket_ids.length ? extra_ticket_ids : undefined,
        }),
        "_self",
      );
    }
  }
}
